module.exports = __webpack_public_path__ + "static/media/order-confirmed.df297ac3.jpg";